<template>
  <div class="product-card" :class="{ 'compact': compact }">
    <a :href="productUrl" class="card-link">
      <!-- Product Image -->
      <div class="card-image">
        <img :src="getProductImage(product.image)" :alt="product.name" />
      </div>

      <!-- Product Info -->
      <div class="card-body">
        <h3 class="product-name">{{ product.name }}</h3>

        <div class="product-price">
          <div class="price-main">
            <span class="current-price">₦{{ formatPrice(product.price) }}</span>
            <span v-if="product.original_price" class="original-price">
              ₦{{ formatPrice(product.original_price) }}
            </span>
          </div>
          <span v-if="saveAmount" class="save-badge-small">Save ₦{{ saveAmount }}</span>
        </div>

        <div class="product-rating">
          <div class="stars">
            <i v-for="n in 5" :key="n"
               :class="n <= Math.round(product.average_rating || product.rating || 0) ? 'fas fa-star' : 'far fa-star'"
            ></i>
          </div>
          <span class="rating-value">{{ product.average_rating || product.rating || 0 }}</span>
          <span class="reviews">({{ product.reviews_count || product.reviews || 0 }})</span>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  product: {
    type: Object,
    required: true
  },
  showSaveBadge: {
    type: Boolean,
    default: false
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const productUrl = computed(() => {
  return `/${props.product.slug || props.product.id}`
})

const saveAmount = computed(() => {
  if (!props.product.original_price || !props.product.price) return null
  const savings = props.product.original_price - props.product.price
  return savings > 0 ? formatPrice(savings) : null
})

const discountPercentage = computed(() => {
  if (!props.product.original_price || !props.product.price) return null
  const discount = ((props.product.original_price - props.product.price) / props.product.original_price) * 100
  return discount > 0 ? Math.round(discount) : null
})

const isOutOfStock = computed(() => {
  // Check various ways stock can be indicated
  if (props.product.stock_status === 'out') return true
  if (props.product.quantity !== undefined && props.product.quantity <= 0) return true
  if (props.product.stock !== undefined && props.product.stock <= 0) return true
  if (props.product.in_stock === false) return true
  return false
})

const stockText = computed(() => {
  return isOutOfStock.value ? 'Out of Stock' : 'In Stock'
})

const stockClass = computed(() => {
  return isOutOfStock.value ? 'out-of-stock' : 'in-stock'
})

const formatPrice = (price) => {
  return new Intl.NumberFormat('en-NG').format(price)
}

const getProductImage = (imagePath) => {
  if (!imagePath) return '/images/placeholder.jpg'
  return imagePath
}
</script>
